export default "__VITE_PUBLIC_ASSET__4ebc6ebb__"